export const SNAPPT_LOGO_SVG = `
  <img
    src="${process.env.PUBLIC_URL}/assets/images/snappt.svg"
    alt="Snappt Logo"
  />
`;

export const CLEAR_LOGO_PNG = `
  <img
    src="${process.env.PUBLIC_URL}/assets/images/CLEAR_Logo_Horizontal_KO_RGB_DIGITAL.png"
    alt="CLEAR Logo"
    width="240"
    height="64"
  />
`;

export const INCODE_LOGO_PNG = `
  <img
    src="${process.env.PUBLIC_URL}/assets/images/incode.png"
    alt="Incode Logo"
    width="240"
    height="64"
  />
`;
